import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  class: "practie-item"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  class: "item-info"
};
var _hoisted_4 = {
  class: "item-state"
};
var _hoisted_5 = ["title"];
var _hoisted_6 = {
  class: "details"
};
import { ref } from 'vue';
import { appAliasEvent } from '@/utils/auth.js';
import { validateNull } from '@/util/validate';
import { skipUrl as skipUrlOpen } from '@/util/util';
export default {
  __name: 'PracticeItem',
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ['change'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var appAliasUrl = ref(null);
    /**
     * 获取关联资源类型
     * @param {Array} val
     * @returns {String}
     */
    var getCiteResType = function getCiteResType(val) {
      var result = val.map(function (val) {
        return "\u5DF2\u5173\u8054 \"".concat(val.citeResType === 1 ? '学程' : '课程', "ID: ").concat(val.uniqueCode, "\"");
      }).join('; ');
      return result;
    };
    //习练跳转
    var openPractice = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(item) {
        var appName, url;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              appName = 'inspirationCentre';
              if (!validateNull(appAliasUrl.value)) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return appAliasEvent(appName);
            case 1:
              appAliasUrl.value = _context.v;
            case 2:
              if (appAliasUrl.value) {
                url = "".concat(appAliasUrl.value, "?").concat(appName, "=%2FpreviewParper%3FresId%3D").concat(item.resId);
                skipUrlOpen(url, '_blank');
              }
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function openPractice(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _props$item, _props$item2;
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_button = _resolveComponent("t-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "item-cover",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return openPractice(__props.item);
        })
      }, [__props.item.cover ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: __props.item.cover || _ctx.coverIcon,
        width: "100%",
        height: "100%",
        alt: ""
      }, null, 8, _hoisted_2)) : (_openBlock(), _createBlock(_component_svg_icon, {
        key: 1,
        name: "cover",
        width: "72px",
        height: "96px"
      }))]), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", {
        class: "title",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return openPractice(__props.item);
        })
      }, _toDisplayString(__props.item.title), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, _toDisplayString(__props.item.pubStatus === 1 ? '已发布' : '未发布'), 1), (_props$item = __props.item) !== null && _props$item !== void 0 && _props$item.resCites ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        title: getCiteResType((_props$item2 = __props.item) === null || _props$item2 === void 0 ? void 0 : _props$item2.resCites)
      }, "已关联", 8, _hoisted_5)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, "编辑时间：" + _toDisplayString(__props.item.updateTime), 1), _createElementVNode("span", null, "创编人： " + _toDisplayString(__props.item.authorName || '--'), 1), _createElementVNode("span", null, "原创人： " + _toDisplayString(__props.item.originalUserName || '--'), 1)])]), _createVNode(_component_t_button, {
        theme: "default",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return emit('change', __props.item);
        })
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[3] || (_cache[3] = [_createTextVNode("查看详情", -1)]));
        }),
        _: 1
      })]);
    };
  }
};